import { render, staticRenderFns } from "./PhysicianMapAndTable.vue?vue&type=template&id=1c421d2b"
import script from "./PhysicianMapAndTable.vue?vue&type=script&lang=js"
export * from "./PhysicianMapAndTable.vue?vue&type=script&lang=js"
import style0 from "./PhysicianMapAndTable.vue?vue&type=style&index=0&id=1c421d2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports